<template>
  <div>
    <add-new-device
      :callback="pushData"
      :counter="counter"
      :isSidebarActive="addNewDevice"
      @closeSidebar="addNewDevice = false"
    />
    <div class="flex flex-wrap justify-between items-center">
      <!-- ITEMS PER PAGE -->
      <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span
              class="mr-2"
            >{{ currentPage * limit - (limit - 1) }} - {{ dataCount - currentPage * limit > 0 ? currentPage * limit : dataCount }} of {{ dataCount }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="fetchData(1, 20)">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="fetchData(1, 50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="fetchData(1, 100)">
              <span>100</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="fetchData(1, 150)">
              <span>150</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="fetchData(1, totalData)">
              <span>Show All</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
      <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
        <!-- <div
          class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
          @click="addNewDevice = true"
        >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
          <span class="ml-2 text-base text-primary">Add Device</span>
        </div>-->
        <vs-button class="mb-4 md:mb-0 mr-4" icon="add" @click="addNewDevice = true">Add Device</vs-button>
      </div>
    </div>

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-material w-100 my-4 ag-grid-table"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="dataTrx"
      rowSelection="multiple"
      colResizeDefault="shift"
      :animateRows="true"
      :floatingFilter="true"
      :pagination="true"
      :paginationPageSize="limit"
      :suppressPaginationPanel="true"
    ></ag-grid-vue>
    <vs-pagination :total="totalPage" :max="maxPageNumbers" v-model="currentPage" />
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import { url } from "@/configs/apiUrl";
import Axios from "@/global/AxiosCall";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import AddNewDevice from "@/views/device/request-device/details/AddDevice.vue";

export default {
  props: {
    dataDevice: {
      type: Array,
      required: true
    },
    callback: {
      type: Function,
      required: true
    }
  },
  components: {
    AgGridVue,
    AddNewDevice
  },
  data() {
    return {
      addNewDevice: false,
      searchQuery: "",
      gridOptions: {},
      maxPageNumbers: 7,
      startData: 1,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: "Device Name",
          field: "name",
          width: 300,
          filter: true
        },
        {
          headerName: "Description",
          field: "notes",
          filter: true,
          width: 600
        },
        {
          headerName: "Action",
          field: "",
          filter: false,
          width: 200
        }
      ],
      dataTrxLocal: [],
      dataTrx: [],
      dataCount: 0,
      totalPage: 0,
      page: 1,
      limit: 20,
      counter:1,
      totalData: 1,
    };
  },
  watch: {
    "$store.state.windowWidth"(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("Channel", null);
      } else this.gridOptions.columnApi.setColumnPinned("Channel", "left");
    },
    dataTrxLocal() {
      if (this.limit < this.dataTrxLocal.length){
        this.limit = 20
      }
      this.fetchData(this.page, this.limit);
    }
  },
  computed: {
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.fetchData(val, this.limit);
      }
    }
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "default"
      });
      setTimeout( ()=> {
        this.$vs.loading.close()
      }, 1000);
    },
    pushData(payload) {
      if (Array.isArray(payload)) {
        for (let i in payload) {
          this.counter++
          this.dataTrxLocal.push(payload[i]);
        }
      } else {
        let found = this.dataTrxLocal.some(el => el.name === payload.name)
        if (!found){
          this.counter++
          this.dataTrxLocal.push(payload);
        }else{
          this.$vs.notify({
            title: "Warning",
            text: "Name already exist",
            iconPack: "feather",
            icon: "icon-check-square",
            color: "warning",
            position: "top-right"
          });
        }
      }
      this.dataCount = this.dataTrxLocal.length;
      this.totalPage = Math.ceil(this.dataTrxLocal.length / this.limit);
      this.callback(this.dataTrxLocal);
    },
    fetchData(page, limit) {
      this.openLoading()
      this.dataTrx = [];
      if (this.dataTrxLocal.length > 0) {
        let startData;
        startData = limit * page - limit;
        let endData = page * limit;

        for (let i = startData; i < endData; i++) {
          if (this.dataTrxLocal[i] !== undefined)
            this.dataTrx.push(this.dataTrxLocal[i]);
        }

        this.dataCount = this.dataTrxLocal.length;
        this.page = page;
        if (limit >= this.dataCount) {
          this.limit = this.dataTrxLocal.length;
        } else {
          this.limit = limit;
        }
        this.gridApi.paginationSetPageSize(this.limit);
        this.totalPage = Math.ceil(this.dataCount / limit);

        this.totalData = this.dataTrxLocal.length
      }
    },
    editRecord(value) {
      this.$router.push({
        name: "issuerMidEdit",
        params: {
          id: value
        }
      });
    },
    deleteRecord(data) {
      let root = this;
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: `Confirm`,
        text: "Are you sure deleted this record ?",
        accept: () => {
          Axios.Delete(url.svd.merchant.account_info + "/" + data)
            .then(resp => {
              if (resp.data === 1) {
                root.fetchData(root.page, root.limit);
                this.$vs.notify({
                  title: "Success",
                  text: "You successfully deleted Issuer MID!",
                  iconPack: "feather",
                  icon: "icon-check-square",
                  color: "success",
                  position: "top-right"
                });
              }
            })
            .catch(e => {
              console.log(e);
              this.$vs.notify({
                title: "Failed",
                text: "Network failed!",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-right"
              });
            });
        }
      });
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridOptions.getRowStyle = function(params) {
      if (params.node.rowIndex % 2 === 0) {
        return { background: '#f9f9f9' }
      }
    }
    this.gridOptions.rowHeight = 42;

    this.$root.$on("delete-from-ActionTableAgGridComponent", data => {
      this.deleteRecord(data);
    });

    this.$root.$on("edit-from-ActionTableAgGridComponent", data => {
      this.editRecord(data);
    });
  }
};
</script>

<style>
</style>
